export const WIZARD_DATA_RECEIVED = 'WIZARD_DATA_RECEIVED'
export const WIZARD_DATA_UNLOADED = 'WIZARD_DATA_UNLOADED'